import classes from "./WelcomeMessage.module.css";
import { useHistory } from "react-router-dom";
import SvgTerms from "./../../assets/images/Terms";
import SvgTermsofuse2 from "./../../assets/images/Termsofuse2";

const WelcomeMessage = (props) => {
  const history = useHistory();
  return (
    <div className={classes.welcome_placeholder}>
      <p>
        Ο Δήμος {props.municipality} σας καλωσορίζει στην Πλατφόρμα Εξυπνης
        Πόλης.
      </p>
      <p> Ενημερωθείτε για τις συνθήκες που επικρατούν στην πόλη μας.</p>
      <div>
        <div style={{ marginBottom: 5 }}>
          <a
            href="http://www.dimosprevezas.gr/epixeiriseis/espa/2014-2020/%CF%80%CE%AF%CE%BD%CE%B1%CE%BA%CE%B1%CF%82-%CE%B4%CE%B7%CE%BC%CE%BF%CF%83%CE%B9%CF%8C%CF%84%CE%B7%CF%84%CE%B1%CF%82-%CF%84%CE%BF%CF%85-%CE%AD%CF%81%CE%B3%CE%BF%CF%85-%CF%80%CE%B9%CE%BB%CE%BF%CF%84/"
            target="_blank"
            style={{
              display: "flex",
              // justifyContent: "center",
              alignContent: "center",
              paddingInline: "5px",
              textDecoration: "none",
              color: "white",
              width: "100%",
              // height: "100%",
            }}
          >
            <p>Πληροφορίες έργου</p>
          </a>
        </div>
        <div
          style={{ marginBottom: 5 }}
          onClick={() => history.push("/terms-of-use")}
        >
          <SvgTermsofuse2 width={35} />

          <p>Δήλωση Προσβασιμότητας</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeMessage;
